import {
  createContext,
  useContext,
  useReducer,
} from "react";
import { AuthContext } from "./AuthContext";

export const ChatContext = createContext();

export const ChatContextProvider = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  const INITIAL_STATE = {
    chatId: "null",
    user: {},
    chatVisibility : false, // this is used to show or hide the sidebar/chat in mobile view
    productId : "null"
  };

  const chatReducer = (state, action) => {
    switch (action.type) {
      case "CHANGE_USER":
        // console.log("payload received : ",action);
        return {
          user: action.payload,
          chatVisibility : true,
        };

      case "BACK_TO_SIDEBAR" : 
        return {
          chatVisibility : false,
        };
      case "SET_PRODUCT" : 
        // console.log("payload received ",action);
        return {
          productId : action.payload,
        };

      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(chatReducer, INITIAL_STATE);

  return (
    <ChatContext.Provider value={{ data:state, dispatch }}>
      {children}
    </ChatContext.Provider>
  );
};
